import Fulfillment from '../containers/Fulfillment';

export default {
  path: ':organization/fulfillment',
  title: 'Fulfillment',
  indexRoute: {
    component: Fulfillment,
  },
};
